import React, { createContext, useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useShopifyCart } from '../../shopify/useShopifyCart';

const defaultCartState = {
  cartId: null,
  couponCode: null,
  isLoading: false,
  addPromo: offerCode => Promise.resolve(null),
};

export const ShopifyCartContext = createContext(defaultCartState);

export const ShopifyCartProvider = ({ children }) => {
  const router = useRouter();
  const [shouldCreateCart, setShouldCreateCart] = useState(false);
  const [hasCheckedPath, setHasCheckedPath] = useState(false);

  useEffect(() => {
    if (router.isReady) {
      setShouldCreateCart(router.pathname.includes('/onboarding'));
      setHasCheckedPath(true);
    }
  }, [router.isReady, router.pathname]);

  const cartState = useShopifyCart({
    shouldCreateCart,
    hasCheckedPath,
  });

  return (
    <ShopifyCartContext.Provider value={cartState}>
      {children}
    </ShopifyCartContext.Provider>
  );
};
export const useShopifyCartContext = () => {
  const context = useContext(ShopifyCartContext);
  if (!context) {
    // Shopify TODO: remove this once we have production validated
    // eslint-disable-next-line no-console
    console.warn(
      'useShopifyCartContext called outside of ShopifyCartProvider, using fallback values',
    );
  }

  return context;
};
